import { Grid } from '@/components/Grid'
import { Slider } from '@/components/Slider/Slider'
import React from 'react'

export function HeuristicSlider({
  label,
  value,
  isDisabled,
  onChange,
}: {
  label: string
  value: number
  isDisabled?: boolean
  onChange: (value: number) => void
}) {
  return (
    <Grid columns="1fr 1fr 20px" style={{ width: '650px', paddingBlock: '5px' }}>
      <div>{label}</div>
      <Slider
        value={value}
        onChange={onChange}
        minValue={0}
        maxValue={5}
        step={0.1}
        isDisabled={isDisabled}
      />
      <div>{value}</div>
    </Grid>
  )
}
